<template>
  <div class="page">
    <van-notice-bar
        left-icon="volume-o"
        text="注意：核销成功后将不可撤销，请认真填写"
    />
    <div class="center">
      <h1>抖音小程序卖品扫码端</h1>
      <van-field v-model="innerCode" size="50" label="影城内码" @change="getInnerCodeInfo"  type="text" placeholder="请填写影城的内码"/>
      <div class="history" v-if="historyInnerCode">
        上次使用内码为：{{ historyInnerCode }} <span class="history-btn" @click="useHistoryInnerCode">使用</span>
      </div>
      <div class="sub">
        <van-button type="info" block @click="getSellList">验证核销</van-button>
      </div>
<!--      <div style="padding-top: 1rem" v-if="orderInfo.length>0">-->
<!--        <van-button type="info" plain block @click="showDetails=!showDetails">显示已核销订单详情</van-button>-->
<!--      </div>-->
      <van-popup
          v-model="showDetails"
          closeable
          position="bottom"
          :style="{ height: '90%' }"
      >
        <div v-if="isVerified" class="water">已核销</div>
        <h2>卖品清单如下：</h2>
        <div class="showDialog" v-for="(order,index) in orderInfo" :key="index">
          <h3>{{ order.skuName }}</h3>
          <ul>
            <li>
              <span>
                名称
              </span>
              <span>
                数量
              </span>
<!--              <span>-->
<!--                价格-->
<!--              </span>-->
            </li>
            <li v-for="(item,index) in order.items" :key="index">
              <span>
                {{ item.name }}
              </span>
              <span>
                x{{ item.count }}  {{ item.unit }}
              </span>
<!--              <span>-->
<!--                {{ (item.price / 100).toFixed(2) }}元-->
<!--              </span>-->
            </li>
          </ul>
        </div>
        <div style="width: 80vw;margin: 5vh auto">
            <van-button type="danger"  block :disabled="isVerified" @click="submitWrite">确认核销</van-button>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import {Toast,Dialog} from "vant";
import axios from "axios";
import config from "@/config";

export default {
  data() {
    return {
      innerCode: '',
      showDetails: false,
      // 是否已经核验卖品
      isVerified: false,
      // 卖品核销码
      sellCode: '',
      // 历史影城内码
      historyInnerCode: '',
      orderInfo: [],
       // 卖品是否核销
      cinema: {},
    }
  },
  mounted() {
    // 卖品核销码
    const code = `${this.$route.params.code}`
    this.sellCode = code;
    // 获取缓存内影院内码
    const historyInnerCode = localStorage.getItem('historyInnerCode')
    if (historyInnerCode) {
      this.historyInnerCode = historyInnerCode
    }
    console.log('卖品核销码', code)
  },
  methods: {
    // 点击使用历史内码
    useHistoryInnerCode() {
      this.innerCode = this.historyInnerCode
      this.getInnerCodeInfo()
    },
    // 查询卖品清单
    getSellList() {
      const host = config.baseURL
      const postUrl = `${host}/dy/miniapp/exchangeSnacks?verificationCode=${this.sellCode}`
      axios.get(postUrl).then(r => {
        console.log(r.data)
        const {code,data,err} =r.data;
        if (code==200){
          console.log('查询卖品清单成功', data)
          this.orderInfo = data.snakes;
          this.isVerified  = data.isExchange;
          this.showDetails = true;
          // this.
        }
        else {
          Toast(err)
        }
      }).catch(e => {
        console.log('查询卖品清单失败', e)
      })
    },
    submitWrite() {
      this.getInnerCodeInfo().then(r=>{
        console.log('获取影院信息成功',r)
        // 提示用户确认核销
        Dialog.confirm({
          title: `${this.cinema.cinemaName}`,
          message: ` 确认已经按照清单进行核销卖品吗？`,
        }).then(() => {
          // on confirm
          this.submitVerification()
        }).catch(() => {
          // on cancel
        });

      })
    },
    // 通过内码查询影院信息
    getInnerCodeInfo() {
      return new Promise((resolve, reject) => {
        const host = config.baseURL
        const postUrl = `${host}/api/dy/miniapp/cinema/innerCode?innerCode=${this.innerCode}`
        if (this.innerCode) {
          axios.get(postUrl).then(r => {
            const {status} = r
            if (status === 200) {
              const {code, data, err} = r.data
              if (code === 200) {
                console.log(data);
                this.cinema = data
                return resolve(data)
              } else {
                Toast(err)
                return reject(err)
              }
            } else {
              Toast.fail('提交失败，可能是网络不通')
              return reject('提交失败，可能是网络不通')
            }
          })
        } else {
          Toast.fail('影城内码不能为空')
        }
      })
    },
    // 提交核销
    submitVerification(){
      const postUrl = `${config.baseURL}/api/dy/miniapp/exchangeSnacks`
      if (this.innerCode&&this.sellCode){
        const postDate ={
          innerCode:this.innerCode,
          verificationCode:this.sellCode
        }
        axios.post(postUrl,postDate).then(r=>{
          const {status} =r
          if (status===200){
            const {code,data,err} = r.data
            if (code===200){
              console.log(data);
              Toast.success('核销成功')
              this.isVerified=true
            }
            else
            {
              Toast(err)
            }
          }
          else {
            Toast.fail('提交失败，可能是网络不通')
          }
        })
        Toast.fail('执行提交')
      }
      else
      {
        Toast.fail('影城内码或者验证码为空')
      }
    },
  },
  filters: {

  }
}
</script>

<style lang="scss">
h1 {
  color: white;
}

.page {
  // 背景渐变
  background: linear-gradient(-45deg, #8c7d3b, rgba(142, 106, 46, 0.35));
  height: 100vh
}

.center {
  padding: 10rem 1rem 0 1rem;
}

.sub {
  margin-top: 5rem;
}

.showDialog {
  padding: 1rem;
  //height: 90%;
  vertical-align: middle;
  h2 {
    text-align: left;
  }

  h3 {
    color: #42b983;
  }

  ul {
    li {
      display: flex;
      align-items: center;
      vertical-align: middle;
      border-bottom: 1px solid #2c3e50;
      padding: 0.5rem 0.1rem;

      span {
        flex: 1;

      }
    }
  }
}

.history {
  color: white;

  &-btn {
    display: inline-block;
    background-color: salmon;
    padding: 1vw;
    margin: 2vw;
  }
}
//水印
.water{
  z-index: -1;
  font-size: 90px;
  transform: rotate(-45deg);
  color: rgba(128, 128, 128, 0.3);
  position: absolute;
  top: 25%;
  left: 20%;
}
</style>
